const navLink = document.querySelectorAll('.nav-link')

navLink.forEach(function (el) {
    el.parentNode.classList.remove('active')
    if (el.pathname === location.pathname && el.hash === location.hash) {
        el.parentNode.classList.add('active')
    }
})

